// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1I7TC","right":"styles_right__GIEIS"};